import React from "react";
import AddressCard from "./AddressCard";

class AddressList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedAddressId: null,
      showNewAddressForm: false,
    };
  }

  componentDidMount() {
    // selectedAddressId prop'tan geliyorsa kullan
    const { addresses, onAddressSelect, selectedAddressId } = this.props;

    if (selectedAddressId) {
      this.setState({ selectedAddressId: selectedAddressId });
    } else if (addresses && addresses.length > 0) {
      // İlk adresi varsayılan olarak seç (aktif adres özelliği kaldırıldı)
      const firstAddress = addresses[0];
      this.setState({ selectedAddressId: firstAddress.id });
      if (onAddressSelect) {
        onAddressSelect(firstAddress);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // Parent'tan gelen selectedAddressId değiştiğinde state'i güncelle
    if (this.props.selectedAddressId !== prevProps.selectedAddressId) {
      this.setState({ selectedAddressId: this.props.selectedAddressId });
    }
  }

  handleAddressSelect = (address) => {
    this.setState({ selectedAddressId: address.id });
    if (this.props.onAddressSelect) {
      this.props.onAddressSelect(address);
    }
  };

  handleNewAddress = () => {
    if (this.props.onNewAddress) {
      this.props.onNewAddress();
    }
  };

  render() {
    const { addresses, onEditAddress, editingAddressId } = this.props;
    const { selectedAddressId } = this.state;

    return (
      <div>
        {addresses && addresses.length > 0 && (
          <div style={styles.header}>
            <h6 style={styles.title}>Teslimat Adresi</h6>
          </div>
        )}

        <div style={styles.addressList}>
          {addresses && addresses.length > 0 && addresses.map(
            function (address) {
              const isEditing = editingAddressId === address.id;

              if (isEditing) {
                // Düzenleme modunda - kart + form göster
                return (
                  <div
                    key={address.id}
                    style={{
                      ...styles.editingCard,
                      ...(selectedAddressId === address.id
                        ? styles.editingCardSelected
                        : {}),
                    }}
                  >
                    <div
                      style={styles.editingCardHeader}
                      onClick={function () {
                        this.handleAddressSelect(address);
                      }.bind(this)}
                    >
                      <div style={styles.radioWrapper}>
                        <input
                          type="radio"
                          checked={selectedAddressId === address.id}
                          onChange={function () {
                            this.handleAddressSelect(address);
                          }.bind(this)}
                          style={styles.radio}
                        />
                      </div>
                      <div style={styles.editingContent}>
                        <h6 style={styles.editingText}>
                          {address.address_name || "Adres"}
                        </h6>
                      </div>
                      <button
                        type="button"
                        onClick={function (e) {
                          e.stopPropagation();
                          if (this.props.onCancelEdit) {
                            this.props.onCancelEdit();
                          }
                        }.bind(this)}
                        style={styles.cancelEditButton}
                      >
                        İptal
                      </button>
                    </div>

                    {/* Form - Düzenleme için */}
                    <div style={styles.editingFormContainer}>
                      {this.props.editAddressForm}

                      {/* Düzenleme Butonları */}
                      <div style={styles.editingActions}>
                        <button
                          type="button"
                          onClick={function (e) {
                            e.stopPropagation();
                            if (
                              this.props.onCancelEdit &&
                              !this.props.isSavingAddress
                            ) {
                              this.props.onCancelEdit();
                            }
                          }.bind(this)}
                          style={{
                            ...styles.cancelButton,
                            ...(this.props.isSavingAddress
                              ? styles.disabledButton
                              : {}),
                          }}
                          disabled={this.props.isSavingAddress}
                        >
                          İptal
                        </button>
                        <button
                          type="button"
                          onClick={function (e) {
                            e.stopPropagation();
                            if (
                              this.props.onSaveEdit &&
                              !this.props.isSavingAddress
                            ) {
                              this.props.onSaveEdit(address.id);
                            }
                          }.bind(this)}
                          style={{
                            ...styles.saveButton,
                            ...(this.props.isSavingAddress
                              ? styles.disabledButton
                              : {}),
                          }}
                          disabled={this.props.isSavingAddress}
                        >
                          {this.props.isSavingAddress ? (
                            <React.Fragment>
                              <i
                                className="fa fa-spinner fa-spin"
                                style={{ marginRight: "8px" }}
                              ></i>
                              Kaydediliyor...
                            </React.Fragment>
                          ) : (
                            "Kaydet"
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                );
              }

              return (
                <AddressCard
                  key={address.id}
                  address={address}
                  isSelected={selectedAddressId === address.id}
                  onSelect={this.handleAddressSelect}
                  onEdit={onEditAddress}
                />
              );
            }.bind(this)
          )}

          {/* Yeni Adres Kartı */}
          <div
            style={{
              ...styles.newAddressCard,
              ...(selectedAddressId === "new"
                ? styles.newAddressCardSelected
                : {}),
            }}
          >
            <div
              style={styles.newAddressCardHeader}
              onClick={this.handleNewAddress}
            >
              <div style={styles.radioWrapper}>
                <input
                  type="radio"
                  checked={selectedAddressId === "new"}
                  onChange={this.handleNewAddress}
                  style={styles.radio}
                />
              </div>
              <div style={styles.newAddressContent}>
                <h6 style={styles.newAddressText}>Yeni Adres</h6>
              </div>
            </div>

            {/* Form - Sadece seçiliyse göster */}
            {selectedAddressId === "new" && this.props.newAddressForm && (
              <div style={styles.newAddressFormContainer}>
                {this.props.newAddressForm}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

const styles = {
  emptyState: {
    textAlign: "center",
    padding: "48px 24px",
    backgroundColor: "#f8f9fa",
    borderRadius: "8px",
    border: "2px dashed #dee2e6",
  },
  emptyIcon: {
    fontSize: "48px",
    color: "#6c757d",
    marginBottom: "16px",
  },
  emptyText: {
    fontSize: "16px",
    color: "#6c757d",
    marginBottom: "24px",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
  },
  title: {
    fontSize: "20px",
    fontWeight: "400",
    color: "#272727",
    margin: 0,
    lineHeight: "32px",
  },
  newAddressButton: {
    backgroundColor: "#84b817",
    color: "#fff",
    border: "none",
    padding: "12px 32px",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  newAddressButtonSmall: {
    backgroundColor: "#fff",
    color: "#84b817",
    border: "2px solid #84b817",
    padding: "8px 20px",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    display: "inline-flex",
    alignItems: "center",
  },
  addressList: {
    marginTop: "16px",
  },
  newAddressCard: {
    border: "1px solid rgb(229, 228, 233)",
    borderColor: "rgb(229, 228, 233)",
    borderRadius: "8px",
    marginBottom: "16px",
    transition: "all 0.2s ease",
    position: "relative",
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  newAddressCardSelected: {
    backgroundColor: "rgb(247, 247, 249)",
    boxShadow: "rgb(132, 184, 23) 0px 0px 0px 1px",
    borderColor: "#84b817",
  },
  newAddressCardHeader: {
    padding: "18px 20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  radioWrapper: {
    marginRight: "12px",
    display: "flex",
    alignItems: "flex-start",
    paddingTop: "4px",
  },
  radio: {
    width: "20px",
    height: "20px",
    cursor: "pointer",
    accentColor: "rgb(95, 141, 0)",
  },
  newAddressContent: {
    flex: 1,
  },
  newAddressText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#272727",
    margin: 0,
  },
  newAddressFormContainer: {
    padding: "0 20px 20px 20px",
    borderTop: "1px solid #e6eaf2",
    marginTop: "0",
    paddingTop: "20px",
  },
  editingCard: {
    border: "2px solid #e6eaf2",
    borderRadius: "12px",
    marginBottom: "16px",
    transition: "all 0.2s ease",
    position: "relative",
    backgroundColor: "#fff",
    overflow: "hidden",
  },
  editingCardSelected: {
    borderColor: "#84b817",
    border: "1px solid rgb(132, 184, 23)",
    borderRadius: "8px",
    backgroundColor: "rgb(247, 247, 249)",
    boxShadow: "rgb(132, 184, 23) 0px 0px 0px 1px",
  },
  editingCardHeader: {
    padding: "18px 20px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
  },
  editingContent: {
    flex: 1,
  },
  editingText: {
    fontSize: "16px",
    fontWeight: "600",
    color: "#272727",
    margin: 0,
  },
  editingFormContainer: {
    padding: "0 20px 20px 20px",
    borderTop: "1px solid #e6eaf2",
    marginTop: "0",
    paddingTop: "20px",
  },
  cancelEditButton: {
    backgroundColor: "transparent",
    border: "none",
    color: "#dc3545",
    padding: "0",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
    marginLeft: "auto",
  },
  editingActions: {
    display: "flex",
    gap: "12px",
    marginTop: "24px",
    justifyContent: "flex-end",
  },
  cancelButton: {
    backgroundColor: "#fff",
    color: "#6c757d",
    border: "1px solid #dee2e6",
    padding: "10px 24px",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "500",
    cursor: "pointer",
    transition: "all 0.2s ease",
  },
  saveButton: {
    backgroundColor: "#84b817",
    color: "#fff",
    border: "none",
    padding: "10px 32px",
    borderRadius: "6px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s ease",
    boxShadow: "0 2px 8px rgba(132, 184, 23, 0.2)",
  },
  disabledButton: {
    opacity: 0.6,
    cursor: "not-allowed",
  },
};

export default AddressList;



// WEBPACK FOOTER //
// ./src/components/AddressStep/AddressList.js